var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['hyf-fondo', { 'hyf-fondo--local': _vm.local }],attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"hyf-fondo__blob hyf-fondo__blob--1"}),_c('span',{staticClass:"hyf-fondo__blob hyf-fondo__blob--2"}),_c('span',{staticClass:"hyf-fondo__blob hyf-fondo__blob--3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }